import Vue from 'vue'

const self = Vue.prototype

export default {

  getOrders(page = 1, params = '') {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.operatorOrders + "?page=" + page + params )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateOrder(id) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.operatorOrders + '/' + id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getHistory(page = 1, params = '') {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.operatorHistory + "?page=" + page + params )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

}